import { render, staticRenderFns } from "./SetOrder.vue?vue&type=template&id=0fab7524&scoped=true&"
import script from "./SetOrder.vue?vue&type=script&lang=js&"
export * from "./SetOrder.vue?vue&type=script&lang=js&"
import style0 from "./SetOrder.vue?vue&type=style&index=0&id=0fab7524&lang=less&scoped=true&"
import style1 from "./SetOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab7524",
  null
  
)

export default component.exports